module.exports = __webpack_public_path__ + "fonts/iconfont.5f263c8b.ttf";